import React from 'react'
import { useInView } from 'react-intersection-observer';
import './header.css'
import CTA from './CTA'
import ME from '../../assets/me.png'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  const { ref: headerRef, inView: myElementIsVisible } = useInView();

  let titleStyle = myElementIsVisible ? 'fade-in' : 'fade-out'

  let titleDev = 'text-light '   
  titleDev += myElementIsVisible ? 'show-from-top' : 'hide-from-top'

  let scrollDown = 'scroll__down '
  scrollDown += myElementIsVisible ? 'fade-in' : 'fade-out'

  let divImage = 'me '
  divImage += myElementIsVisible ? 'fade-in' : 'fade-out'

  let meImage = myElementIsVisible ? 'show-from-bottom' : 'hide-from-bottom'
  return (
    <header ref={headerRef}>
      <div className="container header__container">
        <h5 className={titleStyle}>Hello I'm</h5>
        <h1 className={titleStyle}>Ram Ken</h1>
        <h5 className={titleDev}>Full Stack Developer</h5>
        <CTA />
        <HeaderSocials />

        <div className={divImage}>
          <img className={meImage} src={ME} alt="me" />
        </div>

        <a href="#contact" className={scrollDown}>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header
